var map = {
	"./screenshot-step1.png": "52cc",
	"./screenshot-step2.png": "c556",
	"./screenshot-step3.png": "3055",
	"./screenshot-step4-student.png": "1108",
	"./screenshot-step4-teacher.png": "ce7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f927";